(function () {
  var HOST_RE = /(^|\.)(cdn\.shopify\.com|shopifycdn\.com|cdn\.shopifycdn\.net)$/;

  function buildSrcset(u, widths){
    var list = [];
    for (var i=0;i<widths.length;i++){
      var w = widths[i];
      var nu = new URL(u.href);
      try { nu.searchParams.set('width', w); } catch(e){}
      try { nu.searchParams.set('format', 'webp'); } catch(e){}
      list.push(nu.href + ' ' + w + 'w');
    }
    return list.join(', ');
  }

  function refineSizes(){
    var imgs = document.querySelectorAll('img[data-auto-srcset]');
    for (var i=0;i<imgs.length;i++){
      var img = imgs[i];
      var cw = Math.ceil(img.getBoundingClientRect().width);
      if (cw > 0) img.setAttribute('sizes', cw + 'px');
    }
  }

  function processImages(){
    var imgs = document.querySelectorAll('img:not([data-auto-srcset])');
    for (var i=0;i<imgs.length;i++){
      var img = imgs[i];
      var src = img.getAttribute('src');
      if (!src) continue;
      var u; try { u = new URL(src, location.origin); } catch(e){ continue; }
      if (!HOST_RE.test(u.hostname)) continue;

      if (!img.hasAttribute('srcset')) {
        var widths = [200,300,400,600,800,1000,1200,1600];
        img.setAttribute('srcset', buildSrcset(u, widths));
      }
      if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw');

      if (img.getAttribute('fetchpriority') !== 'high') {
        if (!img.hasAttribute('loading'))  img.setAttribute('loading', 'lazy');
        if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      }
      img.setAttribute('data-auto-srcset','1');
    }

    requestAnimationFrame(refineSizes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processImages, {once:true});
  } else {
    processImages();
  }
  window.addEventListener('load', refineSizes, {once:true});
})();
